import { render, staticRenderFns } from "./monitorAvatarName.vue?vue&type=template&id=56f39674&scoped=true&"
import script from "./monitorAvatarName.vue?vue&type=script&lang=js&"
export * from "./monitorAvatarName.vue?vue&type=script&lang=js&"
import style0 from "./monitorAvatarName.vue?vue&type=style&index=0&id=56f39674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f39674",
  null
  
)

export default component.exports